const COL_NAME_TOKEN = '%COLNAME%';
export default COL_NAME_TOKEN;
